import messagesEventsMap from './messagesEventDefinitions';
import docUploadEventsMap from './docUploadEventDefinitions';
import tasksEventsMap from './taskEventDefinitions';
import { mediaDevicesGoogleTag } from './eventDefinitions';

mediaDevicesGoogleTag();

export default {
  ...messagesEventsMap,
  ...docUploadEventsMap,
  ...tasksEventsMap,
};
